<template>
  <div class="layerRight">
    <!--    <div class="t"><img src="./1.png" width="40" height="40" alt=""></div>-->
    <!--    <div class="t"><img src="./2.png" width="40" height="40" alt=""></div>-->
    <div @mouseenter="wxLive" @mouseleave="wxLeave" class="t"><img src="./3.png" width="40" height="40" alt=""></div>
    <div @click="goTop" class="t"><img src="./4.png" width="40" height="40" alt=""></div>
    <div v-if="is_qr" class="code"><img :src="wxqr" width="150" alt=""></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        scrollTop: '',
        wxqr: '',
        is_qr: false
      }
    },
    created () {
      this.$http.post('/apipx/index/wxqr', {
        token: JSON.parse(localStorage.getItem('login')).token
      }).then(res => {
        // console.log(res)
        this.$store.state.not_read_message = res.data.not_read_message
        this.wxqr = res.data.wxqr
      })
    },
    methods: {
      wxLive () {
        this.is_qr = true
      },
      wxLeave () {
        this.is_qr = false
      },
      handleScroll () { // 获取scrollTop
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      },
      goTop () { // 返回顶部
        let timer = null
        let that = this
        cancelAnimationFrame(timer)
        timer = requestAnimationFrame(function fn () {
          if (that.scrollTop > 0) {
            that.scrollTop -= 100
            document.body.scrollTop = document.documentElement.scrollTop = that.scrollTop
            timer = requestAnimationFrame(fn)
          } else {
            cancelAnimationFrame(timer)
          }
        })
      }
    },
    mounted () { // 监听scroll
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () { // 解除监听scroll
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style type="text/scss" lang="scss">
  .layerRight {
    position: fixed;
    right: 0;
    bottom: 200px;
    width: 75px;
    height: 190px;
    box-shadow: 0px 0px 20px #f3f3f3;
    background-color: #fff;
    overflow: hidden;

    .code {
      position: fixed;
      width: 150px;
      height: 150px;
      right: 95px;
      bottom: 255px;
      z-index: 999;
    }

    .t {
      height: 95px;
      border-bottom: 1px solid #d8d8d8;
      width: 40px;
      margin: 0 auto;
      overflow: hidden;
      cursor: pointer;

      img {
        display: block;
        margin: 30px auto 0;
      }

      &:last-child {
        border: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layerRight/layerRight.vue